<template>
    <div style="position: relative">
        <el-tabs v-model="activeTabName" @tab-click="handleTabClick">
            <el-tab-pane label="会员列表" name="memberList"></el-tab-pane>
            <el-tab-pane label="充值记录" name="rechargeRecord"></el-tab-pane>
            <!-- <el-tab-pane label="会员福利" name="memberWelfare"></el-tab-pane> -->
        </el-tabs>
        <router-view class="router-view"></router-view>
    </div>
</template>

<script lang="ts">
import { createComponent, ref } from "@vue/composition-api"
import { openMessage } from '@/utils/system'
import { routerUtil } from '@/utils/routerUtil'

export default createComponent({
    setup(props, ctx) {
        const {
            activeTabName,
            handleTabClick
        } = routerUtil(ctx)

        return {
            activeTabName,
            handleTabClick
        }
    }
})
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__header {
    margin-bottom: 12px;
}

.router-view {
    height: calc(100vh - 134px);
}
</style>
